/* Mobile Active: screw tip tiles that filter the normal collection grid by product title.
   - Loads every page of the collection into the grid once (the infinite scroll is switched off here),
     so a filter always covers all products, not just the first page.
   - Single screwdrivers of the picked tip first; sets that include that tip after them.
   - Re-applies itself if the theme's own sort/filter rebuilds the grid. */
(() => {
  const root = document.querySelector('[data-ma-tt]');
  if (!root) return;
  const tiles = [...root.querySelectorAll('[data-tt-shape]')];
  if (!tiles.length) return; // all tiles are collection links: nothing to filter

  const RX = {
    pentalobe: /pentalo[bp]e|\bp\s?0?\.8\b|\*\s?0?\.8/i,
    phillips: /phil+ips|convex cross|cross\b|\+\s?\d|\bph\s?0+\b/i,
    tripoint: /tri-?\s?point|\by\s?0?\.\d|\by[\s-]?shape/i,
    torx: /torx|\bt\d\b|\b\d+ip\b/i,
    flat: /\bflat\b|slotted/i,
    electric: /electric|wowstick/i
  };
  const SET_RX = /\bset\b|\bpcs\b|\d+\s?in\s?1\b/i;
  // Bare sizes inside a set's brackets, as used for phone screws.
  const SIZE_MEANS = { '0.6': 'tripoint', '0.7': 'tripoint', '0.8': 'pentalobe', '1.2': 'phillips', '1.3': 'phillips', '1.5': 'phillips', '2.5': 'phillips' };

  const read = (title) => {
    const isSet = SET_RX.test(title);
    const types = new Set();
    Object.keys(RX).forEach((k) => { if (RX[k].test(title)) types.add(k); });
    if (isSet) {
      (title.match(/\(([^)]*)\)/g) || []).forEach((grp) => {
        grp.replace(/(?:^|[\s(/])(\d\.\d)\s?(?:mm)?/g, (m, n) => { if (SIZE_MEANS[n]) types.add(SIZE_MEANS[n]); return m; });
        if (/\bt\d\b/i.test(grp)) types.add('torx');
      });
    }
    return { isSet, types };
  };

  const words = (tile) => (tile.dataset.ttWords || '').split(',').map((w) => w.trim().toLowerCase()).filter(Boolean);
  const titleOf = (li) => {
    const a = li.querySelector('.card__heading a, .card__heading, a');
    return a ? a.textContent.replace(/\s+/g, ' ').trim() : '';
  };

  const matches = (li, tile) => {
    const shape = tile.dataset.ttShape;
    const t = titleOf(li);
    const info = li._tt || (li._tt = read(t));
    const extra = words(tile).some((w) => t.toLowerCase().includes(w));
    if (shape === 'all') return { show: true, set: info.isSet };
    if (shape === 'sets') return { show: info.isSet || extra, set: false };
    return { show: info.types.has(shape) || extra, set: info.isSet };
  };

  const keyOf = (li) => { const a = li.querySelector('a[href*="/products/"]'); return a ? a.getAttribute('href').split('?')[0] : li.innerHTML.length + titleOf(li); };
  let active = tiles.find((t) => t.dataset.ttShape === 'all') || null;
  const setsLast = root.dataset.setsLast === 'true';
  const grid = () => document.getElementById('product-grid');
  const items = () => { const g = grid(); return g ? [...g.children].filter((li) => li.matches('.grid__item')) : []; };

  const apply = () => {
    // drop any product the theme's own scrolling added a second time
    const once = new Set();
    items().forEach((li) => { const k = keyOf(li); if (once.has(k)) li.remove(); else once.add(k); });
    const list = items();
    let shown = 0;
    list.forEach((li) => {
      const r = active ? matches(li, active) : { show: true, set: read(titleOf(li)).isSet };
      li.classList.toggle('ma-tt-hide', !r.show);
      li.style.order = setsLast && r.set ? '1' : '';
      if (r.show) shown++;
    });
    tiles.forEach((t) => {
      const on = t === active;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
      // hide tiles that have nothing to show
      if (t.dataset.ttShape !== 'all') t.hidden = !list.some((li) => matches(li, t).show);
    });
    const empty = root.querySelector('[data-tt-empty]');
    if (empty) empty.hidden = !!shown || !list.length;
  };

  // Load every remaining page into the grid once, then switch the theme's infinite scroll off.
  let loading = null;
  const loadAll = () => {
    if (loading) return loading;
    loading = (async () => {
      const status = document.querySelector('#ProductGridContainer [data-infinite-scroll]');
      let next = status && status.dataset.nextUrl;
      // Switch the theme's infinite scroll off first, so it can't add the same pages too.
      document.querySelectorAll('#ProductGridContainer [data-infinite-scroll], #ProductGridContainer .infinite-scroll-pagination').forEach((el) => el.remove());
      const g = grid();
      const seen = new Set(items().map(keyOf));
      let guard = 0;
      while (next && g && guard++ < 30) {
        try {
          const html = await (await fetch(next, { credentials: 'same-origin' })).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inc = doc.querySelector('#product-grid');
          if (!inc) break;
          [...inc.children].filter((li) => li.matches('.grid__item')).forEach((li) => {
            const k = keyOf(li);
            if (seen.has(k)) return;
            seen.add(k);
            g.append(li);
          });
          const incStatus = doc.querySelector('#ProductGridContainer [data-infinite-scroll]');
          next = incStatus && incStatus.dataset.nextUrl;
          apply();
        } catch (e) { break; }
      }
      loading = null;
      apply();
    })();
    return loading;
  };

  root.addEventListener('click', (e) => {
    const tile = e.target.closest('[data-tt-shape]');
    if (!tile) return;
    e.preventDefault();
    active = tile === active && tile.dataset.ttShape !== 'all' ? (tiles.find((t) => t.dataset.ttShape === 'all') || null) : tile;
    apply();
    const g = grid();
    if (g && g.getBoundingClientRect().top < 0) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // The theme's sort / filters replace the whole grid: load it fully again and re-apply.
  const container = document.getElementById('ProductGridContainer');
  if (container) {
    let last = grid();
    new MutationObserver(() => {
      if (grid() !== last) { last = grid(); loadAll(); }
    }).observe(container, { childList: true, subtree: true });
  }

  // Open with a tip picked: /collections/screwdriver?tip=pentalobe
  const want = new URLSearchParams(location.search).get('tip');
  if (want) active = tiles.find((t) => t.dataset.ttShape === want) || active;

  const start = () => { apply(); loadAll(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
